import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  cocCreateRequest,
  cocCreateSuccess,
  cocCreateFailure,
} = createActions({
  COC_CREATE_SUCCESS: json => json,
}, 'COC_CREATE_REQUEST', 'COC_CREATE_FAILURE');

export function cocCreate(cocData) {
  return (dispatch) => {
    dispatch(cocCreateRequest());
    return create('coc', cocData)
      .then(({ json }) => dispatch(cocCreateSuccess(json)))
      .catch(error => dispatch(cocCreateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/cocs.js